import { CallAPI } from "../../apiManager/ApiCall";
import { getReportURL, getMapReportURL, getProfStatsURL } from "../../apiManager/APIConfig";
import { setReport, setMapReport } from "../../redux/slices/reportSlice";
import { store } from "../../redux/store";

export const GetDashboardReportCall = async () => {
  try {
    const response = await CallAPI({
      url: `${getReportURL}`,
      method: "GET",
    });
    console.log("pippo response", response);

    if (!response?.status) {
      store.dispatch(setReport(response));
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return { status: 400 };
  }
};

export const GetMapReportCall = async () => {
  try {
    const response = await CallAPI({
      url: `${getMapReportURL}`,
      method: "GET",
    });

    if (response?.status == 200) {
      console.log("pippo response", response);

      store.dispatch(setMapReport(response));
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return { status: 400 };
  }
};

const defaultProfStats = () => ({
  studentsCount: 0,
  attemptsLast7Days: {
    labels: [],
    datasets: { label: "Quiz attempts", data: [] },
  },
  quizSummary: [],
  attendanceHeatmap: [],
  attemptsByWeek: { labels: [], datasets: { label: "Attempts", data: [] } },
  scoreDistribution: { labels: ["0-20%", "20-40%", "40-60%", "60-80%", "80-100%"], datasets: { label: "Attempts", data: [0, 0, 0, 0, 0] } },
  activityByDayOfWeek: { labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], datasets: { label: "Attempts", data: [0, 0, 0, 0, 0, 0, 0] } },
  topStudentsByScore: [],
  attemptsByQuizForPie: { labels: [], datasets: { label: "Attempts", data: [] } },
});

export const GetProfStatsCall = async (profId = null) => {
  try {
    const url = profId ? `${getProfStatsURL}?prof_id=${encodeURIComponent(profId)}` : getProfStatsURL;
    const response = await CallAPI({
      url,
      method: "GET",
    });
    const body = response?.data ?? response;
    if (body == null || typeof body !== "object") return defaultProfStats();
    if (body.status >= 400 || (body.message && body.studentsCount === undefined)) return defaultProfStats();
    return body;
  } catch (error) {
    return defaultProfStats();
  }
};
